import commonStrings from './commonStrings';

export default {
  PAY_BUTTON_LABELS: {
    card: 'Charge Card',
    ach: 'Process ACH',
    cash: 'Cash Payment',
  },
  PAY_TYPE_DEFAULTS: {
    card: commonStrings.debit,
    ach: commonStrings.ach,
    cash: commonStrings.cash,
  },
  REDIRECT_PATHS: {
    TRANSACTIONS: '/Transactions',
    INVOICES: '/Invoices',
  },
  NUM_ITEMS_IN_LIST: 100,
  REDIRECT_DELAY_MS: 2000,
};
